// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2sV0i","row":"ProcedureTreatmentSummary_row__2Re1y"};